import { useMemo } from 'react';
import useApiClient from '../api/useApiClient';
import { useGetRegionalConfigsQuery } from '../../store/api-slices/ServiceProviderApiSlice';

/**
 * The regions the platform operates in (backend `regional_configs`), the one source for
 * which countries the dashboard offers.
 *
 * `stateCountries` are the countries split into state-level regions (US, CA, AU today):
 * there the state picks the region, and with it the tax rate and timezone, so it has to
 * be collected. `loaded` tells "no regions" from "not read yet".
 */
export default function useRegions() {
  const { ServiceProvidersManager } = useApiClient();
  const { data: regions, isSuccess } = useGetRegionalConfigsQuery({ apiManager: ServiceProvidersManager });

  return useMemo(
    () => ({
      regions: regions ?? [],
      loaded: isSuccess,
      countries: [...new Set((regions ?? []).map((region) => region.country))],
      stateCountries: [...new Set((regions ?? []).filter((region) => region.state).map((region) => region.country))],
    }),
    [regions, isSuccess],
  );
}
